import api from '@/services/api'
import denormalizeJsonApi from '@/utils/denormalizeJsonApi'
import first from 'lodash/first'

export async function loadProject({ commit, dispatch, getters }, projectId) {
    const response = await api.get(`/api/v1/video-projects/${projectId}/clips`)
    const clips = denormalizeJsonApi(response)

    commit('loadProjectSuccess', { id: projectId, clips })

    dispatch('jumpToClip', first(getters.clipsInPlayOrder).id)
}

export function finishClip({ state, getters, dispatch }) {
    if (state.playingClipId) {
        const playlist = getters.clipsInPlayOrder

        const currentIndex = playlist.findIndex(c => c.id == state.playingClipId)
        const nextIndex = currentIndex + 1
    
        if (nextIndex < playlist.length) {
            const nextClip = playlist[nextIndex]
            dispatch('jumpToClip', nextClip.id)
        } else {
            dispatch('pause')

            const firstClip = first(playlist)
            dispatch('jumpToClip', firstClip.id)
        }
    }
}

export function jumpToClip({ commit }, clipId) {
    commit('jumpToClip', clipId)
}

export function trackRelativeTime({ commit, getters, state }, relativeTime) {
    commit('updateRelativeTime', relativeTime)
}

export function jumpToAbsoluteTime({ commit }, absoluteTime) {
    commit('jumpToAbsoluteTime', absoluteTime)
}

export function jumpToAndPlayClip({ commit, dispatch }, clipId) {
    commit('jumpToClip', clipId)
    dispatch('resume')
}

export function pause({ commit, getters, state }) {
    const clip = getters.getClipById(state.playingClipId)
//    getBuffer(clip).pause()
    commit('paused')
}

export function resume({ commit, getters, state }) {
    const clip = getters.getClipById(state.playingClipId)
//    getBuffer(clip).resume()
    commit('resumed')
}

export function setFullScreen({ commit }, fullScreen) {
    commit('setFullScreen', fullScreen)
}

export function resetState({ commit }) {
    commit('reset')
}

export function setVolume({ commit }, volume) {
    commit('setVolume', volume)
}

export function mute({ commit }) {
    commit('muted')
}

export function unmute({ commit }) {
    commit('unmuted')
}

export function expandAllClips({ commit }) {
    commit('expandedAllClips')
}

export function unexpandAllClips({ commit }) {
    commit('unexpandedAllClips')
}